import { FC, useCallback, useState } from 'react';

import { useAuth } from '@shared/state/hooks/useAuth';

import { CouponHistorySection } from '../components/giftSettlement/CouponHistorySection';
import { CouponPendingSection } from '../components/giftSettlement/CouponPendingSection';

// ─────────────────────────────────────────────
// 상조 쿠폰형 정산 관리 (구 GiftSettlementPage의 쿠폰정산 탭 분리)
// 상조(bugoBrand)에 지급하는 쿠폰형(기프티콘) 정산 전용 페이지 — 단계별 로드.
// 배송형은 GiftSettlementAgencyDeliveryPage, 배송업체는 GiftSettlementSupplyPage.
// ─────────────────────────────────────────────

export const GiftSettlementAgencyCouponPage: FC =
  function GiftSettlementAgencyCouponPage() {
    const { isAdmin, isGiftAgent } = useAuth();
    const canWrite = isAdmin() && !isGiftAgent();
    // GiftAgent(마리) 조회 뷰: viaMari 상조만 노출 + 쓰기 UI 숨김
    const giftAgentView = !isAdmin() && isGiftAgent();

    // 집행 후 내역 섹션 강제 리프레시
    const [historyRefresh, setHistoryRefresh] = useState(0);
    const handleSettled = useCallback(() => {
      setHistoryRefresh((n) => n + 1);
    }, []);

    // 정산서 라인 편집(쿠폰 제외→미정산 복귀 / 추가→미정산 이탈) 후 미정산 섹션 리프레시
    const [pendingRefresh, setPendingRefresh] = useState(0);
    const handleLinesChanged = useCallback(() => {
      setPendingRefresh((n) => n + 1);
    }, []);

    return (
      <div className="min-h-screen bg-gray-50 p-6">
        <div className="mx-auto max-w-screen-2xl">
          <div className="mb-6">
            <h1 className="text-2xl font-bold text-gray-900">상조 쿠폰형 정산 관리</h1>
            <p className="mt-1 text-sm text-gray-500">
              상조 쿠폰형(기프티콘) 정산 조회{canWrite ? ' · 집행 · 수정 · 확정' : ''}
            </p>
          </div>

          {/* 미정산 내역 (상단) */}
          <section className="mb-10">
            <h2 className="mb-4 text-lg font-bold text-gray-800">미정산 내역</h2>
            {canWrite ? (
              <CouponPendingSection
                onSettled={handleSettled}
                refreshTrigger={pendingRefresh}
              />
            ) : (
              <div className="rounded-lg bg-white p-8 text-center text-gray-500 shadow">
                쿠폰 정산 집행은 관리자만 가능합니다.
              </div>
            )}
          </section>

          {/* 정산 완료 내역 (하단) */}
          <section>
            <h2 className="mb-4 text-lg font-bold text-gray-800">정산 완료 내역</h2>
            <CouponHistorySection
              isAdmin={canWrite}
              refreshTrigger={historyRefresh}
              giftAgentView={giftAgentView}
              onLinesChanged={handleLinesChanged}
            />
          </section>
        </div>
      </div>
    );
  };
